// extracted by mini-css-extract-plugin
module.exports =  {"root":"iNXmz4OHBfN9_HmUhGBE"};